import React, { FC, HTMLProps } from 'react';
import styles from './zero_decision_lib.module.scss';

export const ZeroResultsContainer: FC<HTMLProps<HTMLDivElement>> = (props) => (
  <div className={styles.container} {...props} />
);

export const ZeroResultsMain: FC<HTMLProps<HTMLDivElement>> = (props) => (
  <div className={styles.main} {...props} />
);

export const ZeroResultsTitle: FC<HTMLProps<HTMLDivElement>> = (props) => (
  <div className={styles.title} {...props} />
);
